export default __webpack_public_path__ + "static/media/carouselNextGray.280a6162.svg";